import { useState, useEffect, useRef } from "react";
import ConfirmDialog from "./ui/ConfirmDialog";
import { useApi } from "../hooks/useApi";

export default function EmailReminderButton() {
    const { apiCall } = useApi();
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [inProgress, setInProgress] = useState(false);
    const [msg, setMsg] = useState(false);
    const [canSendReminder, setCanSendReminder] = useState(false);
    const [recheckStatus, setRecheckStatus] = useState(false);
    useEffect(() => {

        apiCall(`canForceUncodedSitesReminderBeSent`)
            .then((response) => {
                return response.json();
            }).then((data) => {
                if (data.success) {
                    setCanSendReminder(true);
                    setMsg(data.message);
                }
                else if (data.message) {
                    setMsg(data.message);
                }

            });
    }, [recheckStatus]);



    const sendReminder = () => {
        if (inProgress) return;

        setInProgress(true);

        let success = false;
        apiCall(`manuallyScheduleReminder`, {
            method: "POST",
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                    setCanSendReminder(false);
                    setRecheckStatus(true);
                    setIsDialogOpen(false);
                    success = true;
                    if (data.message) {
                        alert(data.message);
                    }
                } else {

                    if (data.error) {
                        alert(data.error);
                    }
                    else {
                        alert("Error setting up the reminder.");
                    }

                }

            }).finally((data) => {
                setInProgress(false);

            });

    };


    return (
        <div>
            <>
                {!canSendReminder && (
                    <>
                        <div className="text-gray-700 font-medium mb-2 text-center">
                            <button onClick={() => { setIsDialogOpen(true) }} className="mt-3 cursor-pointer bg-amber-600 text-amber-50 p-2  hover:bg-amber-500 rounded transition-colors">Send A Reminder</button>
                        </div>
                        <ConfirmDialog
                            open={isDialogOpen}
                            title="Emails Confirmation"
                            message={msg ? msg : 'Nothing to show'}
                            cancelText="Cancel"
                            hideConfirm
                            onCancel={() => setIsDialogOpen(false)}
                        />
                    </>


                )}
                {canSendReminder && (
                    <>
                        <div className="text-gray-700 font-medium mb-2 text-center">
                            <button onClick={() => { setIsDialogOpen(true) }} className="mt-3 cursor-pointer bg-amber-500 text-amber-50 p-2  hover:bg-amber-500 rounded transition-colors">Send A Reminder</button>
                        </div>
                        <ConfirmDialog
                            open={isDialogOpen}
                            title="Emails Confirmation"
                            message={(msg ? msg : '')}
                            confirmText="Send"
                            cancelText="Cancel"
                            onConfirm={sendReminder}
                            inProgress={inProgress}
                            onCancel={() => setIsDialogOpen(false)}
                        />
                    </>
                )}

            </>



        </div>

    );
};
